import { permisosPorRol } from '@/helpers/permisos'

const rolesStr = localStorage.getItem("roles")
const rolInicial = rolesStr ? JSON.parse(rolesStr)[0]?.rol || null : null

export default {
  namespaced: true,
  state: () => ({
    rol: rolInicial,
    permisos: rolInicial ? permisosPorRol[rolInicial] || {} : {}
  }),
  mutations: {
    setRol(state, nuevoRol) {
      state.rol = nuevoRol
      state.permisos = permisosPorRol[nuevoRol] || {}
      localStorage.setItem('roles', JSON.stringify([{ rol: nuevoRol }]))
    },
    logout(state) {
      state.rol = null 
      state.permisos = {}
      localStorage.removeItem('roles')
    }
  },
  getters: {
    tienePermiso: (state) => (modulo, accion, subAccion = null) => {
      if (!state.rol) return false
      if (state.rol == 'ADMIN') return true
      const mod = state.permisos[modulo]
      if (!mod) return false
      const permiso = mod[accion]
      if (typeof permiso === 'boolean') return permiso
      if (subAccion) return permiso?.[subAccion] === true

      return false
    }
  }
}
